import React, { ReactNode } from 'react'

import { Menu as AntMenu, MenuProps } from 'antd'

const Menu = (props: MenuProps) => {
  return <AntMenu {...props}>{props.children}</AntMenu>
}

export const MenuItem = AntMenu.Item
export const MenuDivider = AntMenu.Divider

export default Menu
